import { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Layouts components
import BaseLayout from "layouts/pages/account/components/BaseLayout";
import Overview from "layouts/pages/home/components/Overview";
import Settings from "layouts/pages/home/components/Settings";

import { useAuth0 } from "@auth0/auth0-react";
import Loading from "components/Loading";
import { addErrorLog } from "../../../Logger/logger";
import { UserContext } from "context/AppProvider/UserContext";
import { getUserData } from "api/UserApi";
import { useSelector } from "react-redux";

function Dashboard() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { setUserData } = useContext(UserContext);
  const { user, isLoading } = useAuth0();
  const [avatar, setAvatar] = useState(null);
  const [hasNoBannerAndAvatar] = useState(true);
  const { users } = useSelector((store) => store?.portal?.users);

  useEffect(() => {
    if (users) {
      setAvatar(users.find((item) => item.auth0_id === user?.cxfUserId)?.image);
    }
  }, [users]);

  useEffect(() => {
    if (!isLoading && user && !user.email_verified) {
      navigate("/authentication/verification");
    }
  }, [isLoading, user, navigate]);

  const getUser = async () => {
    try {
      const fetchedUser = await getUserData(user?.cxfUserId, user?.stripeId);

      setUserData({
        id: fetchedUser?.id || "",
        auth0_id: fetchedUser?.auth0_id || "",
        tenant_id: fetchedUser?.tenant_id || "",
        username: fetchedUser?.username || "",
        user_type: fetchedUser?.user_type || "",
        role_id: fetchedUser?.role_id || "",
        status: fetchedUser?.status || "",
        first_name: fetchedUser?.first_name || "",
        last_name: fetchedUser?.last_name === " " ? "" : fetchedUser?.last_name,
        organization: fetchedUser?.organization === " " ? "" : fetchedUser?.organization,
        mobile: fetchedUser?.mobile === " " ? "" : fetchedUser?.mobile,
        phone: fetchedUser?.phone === " " ? "" : fetchedUser?.phone,
        email_address: fetchedUser?.email_address || "",
        your_location: fetchedUser?.your_location === " " ? "" : fetchedUser?.your_location,
        language: fetchedUser?.language === " " ? "" : fetchedUser?.language,
        image: fetchedUser?.image || "",
      });
    } catch (error) {
      addErrorLog("query Userdata", error, user?.stripeId);
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  if (pathname === "/home/profile") {
    return (
      <>
        <Settings avatar={avatar} getUser={getUser} />
      </>
    )
  }

  return (
    <BaseLayout avatar={avatar} hasNoBannerAndAvatar={hasNoBannerAndAvatar}>
      {pathname === "/home" && <Overview />}
      {pathname === "/analytics/" && <Overview />}
    </BaseLayout>
  );
}

export default Dashboard;
